export var Method;
(function (Method) {
    Method["GET"] = "GET";
    Method["POST"] = "POST";
})(Method || (Method = {}));
export const AnalyticsTag = "Analytics";
export const AppAnalyticsTag = "AppAnalytics";
export const BalancerTag = "Balancer";
export const CoreTag = "Core";
